import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';

const SECTION_LABEL = { settings: 'Settings', cost_basis: 'Cost basis', rates: 'Unit rates', allowances: 'Allowances', costs: 'Package costs', packages: 'Package bands' };
const fmt = (v) => (v == null || v === '' ? '—' : typeof v === 'number' ? v.toLocaleString(undefined, { maximumFractionDigits: 4 }) : String(v));

/** Lists field-level changes between two price-book editions; optional confirm action (Save / Import). */
export function PriceBookDiffDialog({ open, onOpenChange, diff, title, confirmLabel, onConfirm, busy }) {
  const changes = diff?.changes || [];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[820px] max-h-[85vh] overflow-y-auto" data-testid="price-book-diff-dialog">
        <DialogHeader>
          <DialogTitle className="text-base">{title || 'Price book changes'}</DialogTitle>
          <DialogDescription className="text-xs">
            {diff?.a?.name && diff?.b?.name ? `${diff.a.name} → ${diff.b.name} · ` : ''}{changes.length} change{changes.length === 1 ? '' : 's'}
            {changes.length === 0 ? ' — the two editions are identical for rates, allowances, costs and settings.' : ''}
          </DialogDescription>
        </DialogHeader>
        {changes.length > 0 && (
          <table className="w-full text-xs" data-testid="price-book-diff-table">
            <thead><tr className="text-[10px] uppercase text-slate-400 text-left border-b border-slate-200">
              <th className="py-1 pr-2 font-medium">Section</th><th className="py-1 pr-2 font-medium">Package</th><th className="py-1 pr-2 font-medium">Field</th>
              <th className="py-1 pr-2 font-medium text-right">From</th><th className="py-1 font-medium text-right">To</th>
            </tr></thead>
            <tbody>
              {changes.map((c, i) => (
                <tr key={i} className="border-b border-slate-100" data-testid={`price-book-diff-row-${i}`}>
                  <td className="py-1 pr-2 text-slate-500">{SECTION_LABEL[c.section] || c.section}</td>
                  <td className="py-1 pr-2">{c.package || '—'}</td>
                  <td className="py-1 pr-2 font-medium text-[#0F2040]">{c.field.replace(/_/g, ' ')}</td>
                  <td className="py-1 pr-2 text-right tabular-nums text-slate-500 line-through">{fmt(c.from)}</td>
                  <td className="py-1 text-right tabular-nums font-semibold">{fmt(c.to)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)} data-testid="price-book-diff-cancel">{onConfirm ? 'Cancel' : 'Close'}</Button>
          {onConfirm && <Button size="sm" className="bg-[#0F2040] hover:bg-[#1a3260] text-white" onClick={onConfirm} disabled={busy} data-testid="price-book-diff-confirm">{confirmLabel || 'Confirm'}</Button>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
